import { z } from 'zod';

import { CustomerConfigSchema } from './customer-config';
import { UserSchema } from './user';
import { UserRoleSchema } from './user-role';

export const MeSchema = UserSchema.extend({
  uuid: z.string(), // platform id
  tenant: z.string(),
  role: UserRoleSchema,
  config: CustomerConfigSchema,
  whiteLabel: z.boolean().default(false),
  isInternal: z.boolean().default(false),
  isMfaActive: z.boolean().default(false),
});

export type Me = z.infer<typeof MeSchema>;
